import {
  COLORS,
  FONT_SIZES,
  tabFocusedStyles,
  UnstyledButton,
  UnstyledLink,
} from '@aboutyou/ui-components';
import {styled as linariaStyled} from '@linaria/react';
import sc from 'styled-components';

export const IconContainer = sc.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const OffcanvasButton = linariaStyled(UnstyledButton)`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${COLORS.Grey5};
  color: ${COLORS.Black};
  font-size: ${FONT_SIZES.px9};
  height: 48px;
  padding: 0;
  border: 0;
  border-radius: 4px;

  &:focus-visible {
    ${tabFocusedStyles()}
  }
`;

export const StyledLink = linariaStyled(UnstyledLink)`
  display: flex;
  flex-grow: 1;

  &:focus-visible {
    ${tabFocusedStyles()}
  }
`;
